// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconDelivery = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M14.245 23.82c-.45 0-.89-.08-1.32-.24l-10.43-3.91c-.55-.2-.99-.6-1.25-1.13-.37-.74-.32-1.63.15-2.32.46-.69 1.27-1.07 2.09-1.01l7.54.58c.41.03.72.39.69.8-.03.41-.4.71-.81.69l-7.54-.58a.785.785 0 00-.73.35.81.81 0 00-.05.81c.09.19.25.32.44.39l10.44 3.91c.48.18 1.01.19 1.5.03l7.99-2.66a.749.749 0 11.48 1.42l-7.99 2.66c-.4.15-.8.21-1.2.21z"
      fill="currentColor"
    />,
    <path
      d="M17.934 18h-5.79c-.9 0-1.69-.57-1.98-1.43a2.083 2.083 0 011.43-2.67l5.94-1.62a5.3 5.3 0 012.24-.12l3.53.59c.41.07.68.45.62.86a.76.76 0 01-.86.62l-3.53-.59c-.54-.09-1.08-.06-1.6.08l-5.94 1.63a.58.58 0 00-.36.29.57.57 0 00-.04.46c.08.24.3.4.55.4h5.79c.41 0 .75.34.75.75s-.34.75-.75.75zM3.684 13.64c-.41 0-.75-.34-.75-.75V2.25C2.964.97 4.034-.01 5.284 0h13.32c1.24-.02 2.3.97 2.33 2.23v7.66c0 .41-.34.75-.75.75s-.75-.34-.75-.75V2.25a.77.77 0 00-.81-.75H5.265c-.49-.03-.82.33-.83.77v10.62c0 .41-.34.75-.75.75z"
      fill="currentColor"
    />,
    <path
      d="M13.434 7.5h-3c-.83 0-1.5-.67-1.5-1.5V.75c0-.41.34-.75.75-.75h4.5c.41 0 .75.34.75.75V6c0 .83-.67 1.5-1.5 1.5zm-3-6V6h3V1.5h-3z"
      fill="currentColor"
    />
  );
export default SvgIconDelivery;
